function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { BOS, HALIFAX, LLOYDS, MBNA, SCOTTISH_WIDOWS, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT } from "../../constants";
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 8.792l-3.648-1.98v-4.34H17.28v2.547L12 2 0 8.792l.96 1.416 1.728-.944V22h5.568v-8.019h7.392V22h5.664V9.264l1.728.944z",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,21.9997864 L14,15 L10,15 L10,21.9997864 L2,22 L2,12.4142136 C2,11.9427176 2.16648982,11.4883872 2.46691315,11.1298202 L2.58578644,11 L12,1.58578644 L21.4142136,11 C21.7476116,11.333398 21.9511456,11.7723842 21.9922594,12.2383607 L22,12.4142136 L22,22 L14,21.9997864 Z M12,4.414 L4,12.4142136 L4,20 L8,19.9997864 L8,15 C8,13.9456382 8.81587779,13.0818349 9.85073766,13.0054857 L10,13 L14,13 C15.0543618,13 15.9181651,13.8158778 15.9945143,14.8507377 L16,15 L16,19.9997864 L20,20 L20,12.4142136 L12,4.414 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};
HalifaxIcon.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 8.792l-3.648-1.98v-4.34H17.28v2.547L12 2 0 8.792l.96 1.416 1.728-.944V22h5.568v-8.019h7.392V22h5.664V9.264l1.728.944z",
    fillRule: "evenodd"
  }));
};
LloydsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var MaterialIcon = function MaterialIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3 22H8V14H16V22H21V9L12 2.25L3 9V22ZM1 24V8L12 0L23 8V24H14V16H10V24H1Z",
    fill: "currentColor"
  }));
};
MaterialIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.6269478,10.7206308 C24.1033407,11.1514465 24.1265461,11.8729169 23.6788186,12.3329329 L23.4094541,12.6096612 C22.9626367,13.0687787 22.2400846,13.1235853 21.7969072,12.731853 L20.9938189,12.0216135 L20.9938189,22.4173455 C20.9938189,23.0557075 20.4701051,23.5714286 19.8244494,23.5714286 L15.6356495,23.5714286 C14.9899937,23.5714286 14.465825,23.0557075 14.465825,22.4173455 L14.465825,15.1446907 L9.53354275,15.1446907 L9.53354275,22.4173455 C9.53354275,23.0557075 9.01028403,23.5714286 8.36508327,23.5714286 L4.17582841,23.5714286 C3.53017264,23.5714286 3.00645891,23.0557075 3.00645891,22.4173455 L3.00645891,12.0216135 L2.20291551,12.731853 C1.76019313,13.1235853 1.03764108,13.0687787 0.590823631,12.6096612 L0.321004132,12.3329329 C-0.126268327,11.8729169 -0.103517947,11.1514465 0.372874997,10.7206308 L11.1192442,0.994707157 C11.1192442,0.994707157 11.9159625,0.0423303389 12.8810336,0.994707157 L23.6269478,10.7206308 Z"
  }));
};
MbnaIcon.defaultProps = {
  fill: "currentColor",
  fillRule: "evenodd",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.548339 10.3317L10.0915 0.816663C11.1859 -0.2745 12.9577 -0.271882 14.0488 0.822509L23.461 10.3411C24.1854 11.0737 24.1788 12.2548 23.4462 12.9793C23.0969 13.3246 22.6256 13.5182 22.1345 13.5182L20.4881 13.5181L20.5222 23.0673C20.5222 23.5456 20.1621 23.9398 19.6982 23.9937L19.5894 24H14.2844C13.7693 24 13.3517 23.5824 13.3517 23.0673L13.3172 16.8368H10.6001L10.6341 23.0673C10.6341 23.5456 10.274 23.9398 9.81009 23.9937L9.70131 24H4.3563C3.84116 24 3.42355 23.5824 3.42355 23.0673L3.38907 13.5181L1.86549 13.5182C0.882039 13.5182 0.076331 13.7572 0.00511679 11.792L0 11.6528C0 11.157 0.197299 10.6817 0.548339 10.3317ZM22.1345 11.6528L12.7278 2.13966C12.3641 1.77486 11.7735 1.77399 11.4087 2.13771L1.86549 11.6528H4.32272C4.83786 11.6528 5.25546 12.0704 5.25546 12.5855L5.25498 22.3486H8.73505L8.73499 15.9049C8.73499 15.4265 9.09507 15.0323 9.55896 14.9784L9.66774 14.9721H14.2509C14.766 14.9721 15.1836 15.3897 15.1836 15.9049L15.1831 22.3486H18.6231V12.5855C18.6231 12.1072 18.9832 11.7129 19.447 11.659L19.5558 11.6528H22.1345Z",
    fill: "currentColor"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useTheme } from 'styled-components';
export default function (_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme() || {};
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.home) {
    var _theme$assets2, _theme$assets2$icons;
    svg = (_theme$assets2 = theme.assets) === null || _theme$assets2 === void 0 ? void 0 : (_theme$assets2$icons = _theme$assets2.icons) === null || _theme$assets2$icons === void 0 ? void 0 : _theme$assets2$icons.home;
  } else {
    switch (brand) {
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsIcon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = MaterialIcon;
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn("Icon is not available in brand \"".concat(brand, "\"."));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}